import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DetailLine = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S32};
  justify-content: space-between;
  padding: ${Spacing.S8} 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${Color.Grey100};
  }
`

export const OriginatorLinkWrapper = styled.div`
  min-width: 0;
`

export const LabelWrapper = styled.div`
  flex-grow: 1;
  min-width: 0;
`

export const IconWrapper = styled.div`
  flex-shrink: 0;
`
